module.exports = __webpack_public_path__ + "media/images/faq/infl2-38e88096f20379254eac9b73394f093e.png";